import { render, staticRenderFns } from "./forms-file-input.vue?vue&type=template&id=1a3906e4&scoped=true&"
import script from "./forms-file-input.vue?vue&type=script&lang=js&"
export * from "./forms-file-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3906e4",
  null
  
)

export default component.exports